(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rudie-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rudie-bundle-builder')) {
    customElements.define('rudie-bundle-builder', class extends HTMLElement {
      connectedCallback() {
        this.items = new Map();
        // What the cart already holds from this builder (line keys + "id:qty" snapshot),
        // so the bar survives a trip to the cart and the button never adds a bundle twice.
        this.cartBundle = { keys: [], snapshot: '' };
        this.dirty = false;
        this.currency = this.dataset.currency || 'AUD';
        this.cards = [...this.querySelectorAll('.rbb__card')];
        this.cards.forEach((card) => {
          const select = card.querySelector('.rbb__select');
          const slides = [...card.querySelectorAll('[data-gallery-slide]')];
          const showSlide = (nextIndex) => {
            if (!slides.length) return;
            const index = (nextIndex + slides.length) % slides.length;
            slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
            card.querySelector('.rbb__gallery')?.setAttribute('data-gallery-index', index);
            const count = card.querySelector('.rbb__gallery-count b');
            if (count) count.textContent = index + 1;
          };
          card.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
            const current = Number(card.querySelector('.rbb__gallery')?.dataset.galleryIndex || 0);
            showSlide(current - 1);
          });
          card.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
            const current = Number(card.querySelector('.rbb__gallery')?.dataset.galleryIndex || 0);
            showSlide(current + 1);
          });
          const sizeDialog = card.querySelector('.rbb__dialog');
          card.querySelector('[data-size-open]')?.addEventListener('click', () => sizeDialog?.showModal());
          card.querySelector('[data-size-close]')?.addEventListener('click', () => sizeDialog?.close());
          sizeDialog?.addEventListener('click', (event) => {
            if (event.target === sizeDialog) sizeDialog.close();
          });
          select.addEventListener('change', () => {
            card.querySelector('.rbb__card-error').textContent = '';
            this.updateCard(card);
            this.showPreorder(card);
          });
          card.querySelectorAll('.rbb__quantity').forEach((button) => {
            button.addEventListener('click', () => this.changeQuantity(card, button.dataset.action === 'plus' ? 1 : -1));
          });
        });
        this.querySelector('.rbb__chips').addEventListener('click', (event) => {
          const remove = event.target.closest('[data-remove]');
          if (!remove) return;
          this.items.delete(remove.dataset.remove);
          this.dirty = true;
          this.render();
        });
        this.querySelector('.rbb__add').addEventListener('click', () => this.addToCart());
        const trustBar = this.querySelector('.rbb__trust');
        if (trustBar && 'IntersectionObserver' in window) {
          this.footerObserver = new IntersectionObserver((entries) => {
            this.querySelector('.rbb__bar').classList.toggle('is-hidden', entries[0].isIntersecting);
          }, { threshold: 0.05 });
          this.footerObserver.observe(trustBar);
        }
        this.render();
        this.syncFromCart();
        // Back button / bfcache: never leave the button spinning, and re-read the cart.
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted) return;
          this.querySelector('.rbb__add').classList.remove('is-loading');
          this.syncFromCart();
        });
        // The shopper may change or remove bundle items inside the drawer: re-read on close.
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          let wasOpen = drawer.classList.contains('active');
          new MutationObserver(() => {
            const open = drawer.classList.contains('active');
            if (wasOpen && !open) this.syncFromCart();
            wasOpen = open;
          }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
        }
      }

      optionFor(id) {
        for (const card of this.cards) {
          const option = card.querySelector(`.rbb__select option[value="${id}"]`);
          if (option) return { option, card };
        }
        return null;
      }

      itemFrom(option, card, quantity) {
        return {
          id: Number(option.value),
          quantity,
          product: option.dataset.product,
          variant: option.dataset.variant,
          price: Number(option.dataset.price),
          image: option.dataset.image,
          handle: card.dataset.productHandle,
          preorder: option.dataset.preorder || '',
          preorderPct: Number(option.dataset.preorderPct || 0),
          dispatch: option.dataset.dispatch || ''
        };
      }

      snapshotOf(map) {
        return [...map.values()].map((item) => `${item.id}:${item.quantity}`).sort().join(',');
      }

      async syncFromCart() {
        try {
          const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
          const cart = await response.json();
          const lines = (cart.items || []).filter((line) => line.properties && line.properties._rudie_bundle_id && line.properties._rudie_offer === 'mix-match-v4');
          const items = new Map();
          lines.forEach((line) => {
            const found = this.optionFor(line.variant_id);
            if (!found) return;
            const key = String(line.variant_id);
            items.set(key, this.itemFrom(found.option, found.card, (items.get(key)?.quantity || 0) + line.quantity));
          });
          this.cartBundle = { keys: lines.map((line) => line.key), snapshot: this.snapshotOf(items) };
          // Show the bundle that is in the cart, unless the shopper is mid-edit.
          if (!this.dirty) {
            this.items = items;
            // Put each card back on the size that is in the bundle, so the stepper and
            // any pre-order note match what the shopper chose before leaving.
            this.cards.forEach((card) => {
              const select = card.querySelector('.rbb__select');
              if (select.value) return;
              const mine = [...items.values()].find((item) => item.handle === card.dataset.productHandle);
              if (mine) { select.value = String(mine.id); this.showPreorder(card); }
            });
          }
          this.render();
        } catch (error) {
          /* keep whatever the bar shows */
        }
      }

      refreshDrawer(res) {
        const sections = (res && res.sections) || {};
        if (sections['cart-drawer']) {
          const fresh = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          const current = document.querySelector('#CartDrawer');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        if (sections['cart-icon-bubble']) {
          const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const next = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && next) bubble.innerHTML = next.innerHTML;
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.classList.remove('is-empty');
          drawer.open();
        } else {
          window.location.href = this.dataset.cartUrl;
        }
      }

      async openDrawer() {
        try {
          const response = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`, { cache: 'no-store' });
          this.refreshDrawer({ sections: await response.json() });
        } catch (error) {
          window.location.href = this.dataset.cartUrl;
        }
      }

      changeQuantity(card, change) {
        const select = card.querySelector('.rbb__select');
        if (!select.value) {
          card.querySelector('.rbb__card-error').textContent = 'Choose a size first.';
          select.focus();
          return;
        }
        const option = select.selectedOptions[0];
        if (change > 0 && card.dataset.productHandle !== 'bamboo-wireless-bra' && [...this.items.values()].filter((item) => item.handle !== 'bamboo-wireless-bra').reduce((sum, item) => sum + item.quantity, 0) >= 5) {
          card.querySelector('.rbb__card-error').textContent = 'Your 5-pair bundle is full. Remove a pair to swap styles or sizes.';
          return;
        }
        card.querySelector('.rbb__card-error').textContent = '';
        const key = select.value;
        const current = this.items.get(key);
        const quantity = Math.max(0, (current?.quantity || 0) + change);
        this.dirty = true;
        if (quantity === 0) {
          this.items.delete(key);
        } else {
          this.items.set(key, {
            id: Number(key),
            quantity,
            product: option.dataset.product,
            variant: option.dataset.variant,
            price: Number(option.dataset.price),
            image: option.dataset.image,
            handle: card.dataset.productHandle,
            preorder: option.dataset.preorder || '',
            preorderPct: Number(option.dataset.preorderPct || 0),
            dispatch: option.dataset.dispatch || ''
          });
        }
        this.render();
      }

      showPreorder(card) {
        const option = card.querySelector('.rbb__select').selectedOptions[0];
        const note = card.querySelector('.rbb__preorder');
        if (!note) return;
        const on = Boolean(option?.dataset.preorder);
        note.hidden = !on;
        if (on) {
          note.querySelector('[data-preorder-head]').textContent = `Restocking. Pre-order this size for ${option.dataset.preorderPct || 10}% off`;
          note.querySelector('[data-preorder-body]').textContent = `Estimated dispatch from ${option.dataset.dispatch}. Your whole bundle ships together then.`;
        }
      }

      updateCard(card) {
        const select = card.querySelector('.rbb__select');
        card.querySelector('.rbb__quantity-value').textContent = this.items.get(select.value)?.quantity || 0;
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: this.currency }).format(cents / 100);
      }

      tier(count) {
        if (count >= 5) return { discount: 40, message: '40% unlocked on your 5-pair bundle!' };
        if (count >= 3) return { discount: 33, message: `33% unlocked. Add ${5 - count} more for 40% off.` };
        return { discount: 0, message: `Add ${3 - count} more pairs to save 33%.` };
      }

      render() {
        const values = [...this.items.values()];
        const count = values.reduce((sum, item) => sum + item.quantity, 0);
        const pairCount = values.filter((item) => item.handle !== 'bamboo-wireless-bra').reduce((sum, item) => sum + item.quantity, 0);
        const subtotal = values.reduce((sum, item) => sum + item.price * item.quantity, 0);
        const tier = this.tier(pairCount);
        // Mirrors rudie-mix-match-discount: bundle saving first, then the pre-order
        // percent on what is left, both rounded per line. Bralette is outside the bundle.
        const total = values.reduce((sum, item) => {
          const line = item.price * item.quantity;
          if (item.handle === 'bamboo-wireless-bra') return sum + line;
          const bundle = Math.round(line * tier.discount / 100);
          const extra = item.preorder ? Math.round((line - bundle) * (item.preorderPct || 0) / 100) : 0;
          return sum + line - bundle - extra;
        }, 0);
        const hasPreorder = values.some((item) => item.preorder);
        this.style.setProperty('--progress', `${Math.min(pairCount / 5 * 100, 100)}%`);
        this.querySelectorAll('[data-tier]').forEach((item) => item.classList.toggle('is-active', pairCount >= Number(item.dataset.tier)));
        this.querySelectorAll('[data-point]').forEach((item) => item.classList.toggle('is-active', pairCount >= Number(item.dataset.point)));
        this.querySelector('.rbb__progress-message').textContent = tier.message;
        this.querySelector('.rbb__bar-message').textContent = tier.message;
        this.querySelector('.rbb__count').textContent = count;
        this.cards.forEach((card) => {
          const productCount = values.filter((item) => item.handle === card.dataset.productHandle).reduce((sum, item) => sum + item.quantity, 0);
          card.classList.toggle('is-selected', productCount > 0);
          card.querySelector('.rbb__product-count').textContent = productCount;
          this.updateCard(card);
        });
        const chips = this.querySelector('.rbb__chips');
        chips.innerHTML = values.length ? values.map((item) => `
          <div class="rbb__chip">
            <img src="${item.image}" width="42" height="42" alt="">
            <div><strong>${item.product}</strong><span>${item.variant} · ×${item.quantity}${item.preorder ? ' · <em>Pre-order</em>' : ''}</span></div>
            <button type="button" data-remove="${item.id}" aria-label="Remove ${item.product}, ${item.variant}">×</button>
          </div>`).join('') : '<span class="rbb__empty">Your selected styles will appear here.</span>';
        const oldTotal = this.querySelector('.rbb__total s');
        oldTotal.hidden = total >= subtotal;
        const barNote = this.querySelector('.rbb__bar-preorder');
        if (barNote) {
          const first = values.find((item) => item.preorder);
          barNote.hidden = !hasPreorder;
          if (first) barNote.textContent = `Your bundle includes a pre-order size, so the whole order ships together from ${first.dispatch}.`;
        }
        oldTotal.textContent = this.formatMoney(subtotal);
        this.querySelector('.rbb__total strong').textContent = this.formatMoney(total);
        const button = this.querySelector('.rbb__add');
        const inCart = this.cartBundle && this.cartBundle.snapshot;
        const same = count > 0 && inCart && this.snapshotOf(this.items) === inCart;
        button.disabled = count === 0;
        button.dataset.mode = same ? 'view' : inCart ? 'update' : 'add';
        button.textContent = same
          ? 'View bundle in cart'
          : count
            ? (inCart ? 'Update bundle in cart' : `Add ${count} item${count === 1 ? '' : 's'} to cart`)
            : 'Add bundle to cart';
      }

      async addToCart() {
        const button = this.querySelector('.rbb__add');
        if (!this.items.size || button.classList.contains('is-loading')) return;
        if (button.dataset.mode === 'view') {
          await this.openDrawer();
          return;
        }
        button.classList.add('is-loading');
        button.disabled = true;
        const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        try {
          // Replace, never stack: take the previous builder bundle out first.
          if (this.cartBundle.keys.length) {
            const updates = Object.fromEntries(this.cartBundle.keys.map((key) => [key, 0]));
            const cleared = await fetch(`${this.dataset.cartUrl}/update.js`, { method: 'POST', headers, body: JSON.stringify({ updates }) });
            if (!cleared.ok) throw new Error('Cart update failed');
          }
          const bundleId = crypto.randomUUID();
          const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers,
            body: JSON.stringify({
              items: [...this.items.values()].map((item) => ({ id: item.id, quantity: item.quantity, properties: { '_Bundle': 'Build Your Rudie Bundle', '_rudie_offer': 'mix-match-v4', '_rudie_bundle_id': bundleId, ...(item.preorder ? { '_rudie_preorder_batch': item.preorder } : {}) } })),
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });
          if (!response.ok) throw new Error('Cart request failed');
          const result = await response.json();
          this.dirty = false;
          button.classList.remove('is-loading');
          this.refreshDrawer(result);
          await this.syncFromCart();
        } catch (error) {
          button.classList.remove('is-loading');
          button.disabled = false;
          button.textContent = 'Try adding your bundle again';
          this.syncFromCart();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
